import React from 'react';

const MATCHES = [
    { code: 'IM', color: '#2ED9A5', title: 'InvestorMatch', body: 'Get in front of the right investors, introduced by people who know you both.' },
    { code: 'AM', color: '#F6C445', title: 'AdvisorMatch', body: "Find advisors who've actually sat where you're sitting." },
    { code: 'PM', color: '#4A67FF', title: 'PartnerMatch', body: 'Build the commercial relationships that make a deal, or a business, work.' },
];

// Floating labels over the photo. Percentages and translate values come straight from the design.
const PILLS = [
    { label: 'Investor', color: '#2ED9A5', style: { top: '20px', left: '3.7%', transform: 'translateX(-15%)' } },
    { label: 'Advisor', color: '#F6C445', style: { top: '20px', left: '92.7%', transform: 'translateX(-85%)' } },
    { label: 'Partner', color: '#4A67FF', style: { bottom: '20px', left: '41.2%', transform: 'translateX(-50%)' } },
    { label: 'Company', color: '#FC7785', style: { top: '20px', left: '64%', transform: 'translateX(-50%)' } },
];

const CommunityEcosystemSection = () => (
    <section className="lp-cm-eco">
        <div className="lp-cm-eco-inner">
            <div>
                <span className="lp-cm-eyebrow" data-lp-reveal><span className="dot" />Our ecosystem</span>
                <h2 className="lp-cm-h2" data-lp-reveal data-lp-delay="60">An interdependent ecosystem for companies, advisors and investors.</h2>
                <p className="lp-cm-lead" data-lp-reveal data-lp-delay="120">Qualified dealflow and opportunities in and out, to and from likeminded people already on our platform.</p>
                <div className="lp-cm-match-list">
                    {MATCHES.map((m, i) => (
                        <div className="lp-cm-match" key={m.code} data-lp-reveal data-lp-delay={180 + i * 80}>
                            <div className="lp-cm-match-badge" style={{ background: m.color }}>{m.code}</div>
                            <div>
                                <b>{m.title}</b>
                                <span>{m.body}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="lp-cm-eco-photo" data-lp-reveal data-lp-delay="140">
                <img src={require('../../../../images/landing-pages/community/ecosystem-people.webp')} alt="Founders, advisors and investors together" />
                {PILLS.map(p => (
                    <span className="lp-cm-eco-pill" key={p.label} style={p.style}>
                        <span className="dot" style={{ background: p.color }} />{p.label}
                    </span>
                ))}
            </div>
        </div>
    </section>
);

export default CommunityEcosystemSection;
